import { Injectable } from '@angular/core';
import { HelperFunctions } from 'bowman-commons';
import { Observable, Subject } from 'rxjs';
import { TabItem } from './model/tab-item';

@Injectable({
  providedIn: 'root'
})
export class DashboardDataService {
  private tabs$: Subject<Array<TabItem>>;
  private tabList: Array<TabItem>;
  private discoveryTabs$: Subject<Array<TabItem>>;
  private discoveryTabList: Array<TabItem>;
  private widgets$: Subject<Map<string, Map<string, string>>>;
  private widgetMap: Map<string, Map<string, string>>;
  private dynamicModules$: Subject<Array<any>>;
  private dynamicModulesList: Array<any>;

  constructor() {
    this.tabs$ = new Subject<Array<TabItem>>();
    this.tabList = [];
    this.discoveryTabs$ = new Subject<Array<TabItem>>();
    this.discoveryTabList = [];
    this.tabs$.next(this.tabList);
    this.widgets$ = new Subject<Map<string, Map<string, string>>>();
    this.widgetMap = new Map();
    this.widgets$.next(this.widgetMap);
    this.dynamicModules$ = new Subject<Array<any>>();
    this.dynamicModulesList = [];
    this.dynamicModules$.next(this.dynamicModulesList);
  }


  public addDynamicModule(module: any): void {
    this.dynamicModulesList.push(module);
    this.dynamicModules$.next(this.dynamicModulesList);
  }

  public listDynamicModules(): Observable<Array<any>> {
    return this.dynamicModules$;
  }

  public addTab(tab: TabItem): void {
    this.tabList.forEach(t => { t.active = false });
    tab.active = true;
    this.tabList.push(tab);
    this.tabs$.next(this.tabList);
  }

  public updateTab(tab: TabItem): void {
    this.tabList.filter(t => t.id == tab.id).map(t => t = HelperFunctions.cloneObject(tab));
  }

  public removeTab(tab: TabItem): void {
    this.tabList.forEach(t => { t.active = false });
    let index: number = this.tabList.indexOf(tab);
    if (tab.parentId && tab.parentId != null) {
      this.tabList.filter(t => t.objId == tab.parentId).map(t => t.active = true);
    } else {
      if (index > 0) {
        this.tabList[index - 1].active = true;
      }
    }
    this.tabList.splice(index, 1);
    this.tabs$.next(this.tabList);
  }

  public listTabs(): Observable<Array<TabItem>> {
    return this.tabs$;
  }
  public getTabs(): Array<TabItem> {
    return this.tabList;
  }

  public listWidgets(): Observable<Map<string, Map<string, string>>> {
    return this.widgets$;
  }

  public addWidget(dashboardId: string, widgets: Map<string, string>) {
    this.widgetMap.set(dashboardId, widgets);
    this.widgets$.next(this.widgetMap);
  }

  public addDiscoveryTab(tab: TabItem): void {
    this.discoveryTabList.forEach(t => { t.active = false });
    tab.active = true;
    this.discoveryTabList.push(tab);
    this.discoveryTabs$.next(this.discoveryTabList);
  }


  public removeDiscoveryTab(tab: TabItem): void {
    this.discoveryTabList.forEach(t => { t.active = false });
    let index: number = this.discoveryTabList.indexOf(tab);
    if (index > 0) {
      this.discoveryTabList[index - 1].active = true;
    }
    this.discoveryTabList.splice(index, 1);
    this.discoveryTabs$.next(this.discoveryTabList);
  }

  public listDiscoveryTabs(): Observable<Array<TabItem>> {
    return this.discoveryTabs$;
  }
  public getDiscoveryTabs(): Array<TabItem> {
    return this.discoveryTabList;
  }
}
